import React from 'react'
import styled from '@emotion/styled'
import { Colors, Shapes } from 'src/components/theme'
import { IconButton } from '@mui/material'
import { HelpOutline as HelpCircle } from '@emotion-icons/material/HelpOutline'
import { InsightCardWrapperProps } from 'src/components/insights/common/cards/card'
import { InsightCardLoadingBoundary } from '.'
import { HelpTooltip } from 'src/components/help-tooltip'

type InsightCardProps = {
  header?: React.ReactNode
  children?: React.ReactNode
  tooltipFile?: string
}

export const InsightCardTabsWrapper = styled.div<InsightCardWrapperProps>`
  width: 100%;
  background-color: ${Colors.bgWhite};
  margin: ${Shapes.spacing[4]}px 0;
  border: 1px solid ${Colors.border};
  padding: 0;
  border-radius: ${(props: InsightCardWrapperProps) =>
    props.isFooterOpen ? `${Shapes.borderRadius}px ${Shapes.borderRadius}px 0 0` : Shapes.borderRadius}px;
  overflow: hidden;
`

const InsightCardTabsHeader = styled.div`
  background-color: ${Colors.bgLight};
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0px ${Shapes.spacing[5]}px;
  border-bottom: 1px solid ${Colors.border};
`

const InsightCardTabsHeaderLeft = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-bottom: -2px;
`

const InsightCardTabsRightBtn = styled(IconButton)`
  width: 12px;
  height: 12px;
  padding: 0;
`

const InsightCardTabsHelpCircleIcon = styled(HelpCircle)`
  width: 12px;
  height: 12px;
`

const InsightCardTabsContent = styled.div`
  min-height: 215px;
  padding: ${Shapes.spacing[7]}px ${Shapes.spacing[5]}px;
`

export const InsightCardTabs: React.FC<InsightCardProps> = (props) => {
  const { header, children, tooltipFile } = props

  return (
    <InsightCardTabsWrapper>
      <InsightCardTabsHeader>
        <InsightCardTabsHeaderLeft>{header}</InsightCardTabsHeaderLeft>
        {tooltipFile && (
          <HelpTooltip file={tooltipFile} placement="bottom" immediate>
            <InsightCardTabsRightBtn aria-label="Help">
              <InsightCardTabsHelpCircleIcon />
            </InsightCardTabsRightBtn>
          </HelpTooltip>
        )}
      </InsightCardTabsHeader>
      <InsightCardTabsContent>
        <InsightCardLoadingBoundary>{children}</InsightCardLoadingBoundary>
      </InsightCardTabsContent>
    </InsightCardTabsWrapper>
  )
}
